export const GET_SALES_TAX_REQUEST="GET_SALES_TAX_REQUEST"
export const GET_SALES_TAX_SUCCESS="GET_SALES_TAX_SUCCESS"
export const GET_SALES_TAX_FAILURE="GET_SALES_TAX_FAILURE"